<script lang="ts">
  import datadogRumHelper from '$lib/helpers/browser/datadog-rum-helper';
  import pwtHelper from '$lib/helpers/browser/pwt-helper';
  import { PublicWebNav, PublicWebNavV2 } from '@squareup/public-web-nav/svelte';

  const renderNavV2 = $$props.renderNavV2;

  let publicWebNavWrapper: HTMLElement;
  let publicWebNavMountedEvent: CustomEvent<any> | null = null;

  const PUBLIC_WEB_NAV_READY = 'public-web-nav-ready';

  async function logDDRum(meta: any) {
    pwtHelper.subscribeDependents();
    datadogRumHelper.logAction('pwn_load', meta);
  }

  function onPublicWebNavMount(e: CustomEvent<any>) {
    publicWebNavMountedEvent = e;
  }

  function notifyPublicWebNavReady(wrapper: HTMLElement | undefined, mountEvent: CustomEvent<any> | null) {
    if (!wrapper || !mountEvent) {
      return;
    }

    logDDRum(mountEvent.detail.meta);

    // Set data attribute
    wrapper.dataset.ready = 'true';

    // Dispatch an event that can be listened to
    const navReadyEvent = new Event(PUBLIC_WEB_NAV_READY);
    publicWebNavWrapper.dispatchEvent(navReadyEvent);
  }

  $: notifyPublicWebNavReady(publicWebNavWrapper, publicWebNavMountedEvent);
</script>

<header>
  <div id="public-web-nav" data-tracking-parent-id="public-web-nav" bind:this={publicWebNavWrapper}>
    {#if renderNavV2}
      <PublicWebNavV2 {...$$props} on:mount={onPublicWebNavMount} />
    {:else}
      <PublicWebNav {...$$props} on:mount={onPublicWebNavMount} />
    {/if}
  </div>
</header>

<style lang="scss" global>
  /*
    TODO(PWB-765): Move this to PWN
    Limit nav and subnav contents to body max width
  */
  @use '@squareup/public-web-design-system/dist/styles/xms-fe/variables.scss' as vars;

  .PublicWebNav {
    nav {
      &.MobileNav,
      &.DesktopNav {
        --nav-outer-gutter-base: calc(var(--space-10) / 2);

        // Update padding
        padding-left: var(--nav-outer-gutter-base) !important;
        padding-right: var(--nav-outer-gutter-base) !important;
      }

      &.CtaSubnavMobileNav,
      &.CtaSubnavDesktopNav {
        --nav-outer-gutter-base: calc(var(--space-30) / 2);
      }

      &.CtaSubnavMobileNav .HeaderMenu .truncate-wrapper,
      &.CtaSubnavMobileNav .footer,
      &.CtaSubnavDesktopNav .header {
        padding-left: var(--nav-outer-gutter-base) !important;
        padding-right: var(--nav-outer-gutter-base) !important;

        ul.nav-list > li:last-child {
          padding-right: 0 !important;
        }
      }

      &.CtaSubnavMobileNav .HeaderMenu .toggle {
        padding-right: 0 !important;
      }

      @media (min-width: vars.$breakpoint-width-extra-large) {
        &.DesktopNav,
        &.MobileNav {
          --nav-outer-gutter: max(
            var(--nav-outer-gutter-base),
            calc((100vw - var(--body-width-max) - var(--space-30)) / 2)
          );

          // using padding to maintain border bottom
          padding-left: var(--nav-outer-gutter) !important;
          padding-right: var(--nav-outer-gutter) !important;
        }

        // very hacky fix due to dom structure of subnav
        &.CtaSubnavDesktopNav {
          --nav-outer-gutter: max(var(--nav-outer-gutter-base), calc((100vw - var(--body-width-max)) / 2));

          .header {
            // using padding to maintain border bottom
            padding-left: var(--nav-outer-gutter) !important;
            padding-right: var(--nav-outer-gutter) !important;
          }
        }
      }
    }
  }
</style>
